














































import { Component, Vue } from 'vue-property-decorator';
import services from '@/services';
import * as amplitude from 'amplitude-js';
import {
  ClientItemCatalogItemsDTO, CatalogItemShortDTO, ItemDTO,
} from '@/api';
import { clientsModule } from '@/store';
import EditingLayout from '@/layouts/EditingLayout.vue';
import { getAssetUrl, throwError } from '@/utils';

@Component({
  name: 'ai-things-page',
  components: {
    EditingLayout,
  },
})
export default class AiThingsPage extends Vue {
  groups: ClientItemCatalogItemsDTO[] = [];

  loading = false;

  async created() {
    this.fetchThings();
    amplitude.getInstance().logEvent('Открыта страница вещей для вещей аи');
  }

  fetchThings() {
    const amount = this.$route.query.amount ? Number(this.$route.query.amount) : 1;
    const ids = (Array.isArray(this.$route.query.ids) ? this.$route.query.ids : [])
      .map(id => Number(id));

    this.loading = true;

    services.aiApi().aiEndpointFindThingsForThing({ amount, clientItemIds: ids })
      .then(({ data }) => {
        this.groups = data;
      })
      .catch((e) => {
        throwError('Ошибка загрузка параметров поиска')(e);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get options() {
    return (this.$route?.meta?.options || []);
  }

  get client() {
    return clientsModule.model;
  }

  back() {
    this.$router.push({ name: this.options.back });
  }

  getImage(item: CatalogItemShortDTO) {
    return item ? getAssetUrl(item.pictUrl) : null;
  }

  getClientThinImage(item: ItemDTO) {
    return item && item.fileNames && item.fileNames.length
      ? item.fileNames[0].fileName
      : null;
  }

  selectAmount(count: number) {
    this.$router.push({ query: { ...this.$route.query, amount: String(count) } });
    this.fetchThings();
  }
}

